import { render, staticRenderFns } from "./DriverSelector.vue?vue&type=template&id=5b206880&lang=pug"
import script from "./DriverSelector.vue?vue&type=script&lang=js"
export * from "./DriverSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports